@use 'kci-design-lib/styles/variables.scss' as *;
.toggle-switch-container {
  display: flex;
  align-items: center;
  label {
    color: var(--toggle-label-color);
    line-height: 24px;
    font-size: 16px;
  }
  &.no-label {
    .toggle-switch {
      margin: 0;
    }
  }
}
.toggle-switch {
  color: var(--main-text);
  position: relative;
  width: 32px;
  height: 16px;
  cursor: pointer;
  margin-right: 12px;
  display: inline-flex;
  &.checked {
    [data-pc-section='slider'] {
      background: $pbl-bkgd;
      width: 32px;
      height: 16px;
      &:before {
        background: $pcl-main-bkgd;
        width: 12px;
        height: 12px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        left: -3px;
        top: 11px;
      }
    }
  }
  &.disabled {
    opacity: 1;
    [data-pc-section='slider'] {
      background: $color-border-subtle;
      width: 32px;
      height: 16px;
      &:before {
        background: $pbl-text-dsbl;
      }
    }
    color: $pbl-text-dsbl;
    & ~ label {
      color: var(--toggle-label-disabled-color);
      cursor: default;
    }
    &.checked {
      [data-pc-section='slider'] {
        &:before {
          background: $pbl-text-dsbl;
          width: 12px;
          height: 12px;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          left: -3px;
          top: 11px;
        }
      }
    }
  }
  [data-pc-section='slider'] {
    background: $pbl-text-dsbl;
    width: 32px;
    height: 16px;
    position: relative;
    &:before {
      background: $pcl-main-bkgd;
      width: 12px;
      height: 12px;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 2px;
      top: 11px;
    }
  }
}
[data-theme='dark'] {
  .toggle-switch-container {
    label {
      color: $border-dark;
    }
  }
  .toggle-switch {
    [data-pc-section='slider'] {
      background: #35394c;
      &:before {
        background: #0e162b;
      }
    }
    &.checked {
      [data-pc-section='slider'] {
        background: $blue-icon-bkg;
        &:before {
          background: #0e162b;
        }
      }
    }
    &.disabled {
      [data-pc-section='slider'] {
        background: $pbl-text-dsbl;
        &:before {
          background: $text-dark-white;
        }
      }
      &.checked {
        [data-pc-section='slider'] {
          background: $pbl-text-dsbl;
          &:before {
            background: $text-dark-white;
          }
        }
      }
    }
  }
}
